<template>
	<Container>
		<Subtitle>
			{{ $t('Genera_firmas') }}
		</Subtitle>
		<div class="p-4">
			<div class="lg:flex">
				<div class="lg:w-2/3 mb-4 lg:pr-2">
					<label class="block mb-2">{{ $t('Tipo_firma') }}</label>
					<select v-model="organization_id" class="w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none">
						<option v-for="(organization, index) in organizations" :value="organization.id" :key="index" :selected="organization.id == organization_id">
							{{ organization.name }}
						</option>
					</select>
					<div v-if="$v.organization_id.$dirty">
						<div class="text-sm text-red-500 mt-2" v-if="!$v.organization_id.required">
							{{ $t('category_required') }}
						</div>
					</div>
				</div>
			</div>
			<div v-if="organization_id == 2 || organization_id == 3" class="lg:flex">
				<div class="lg:w-2/3 mb-4 lg:pr-2">
					<label class="block mb-2">{{ $t('delegation') }}</label>
					<select v-model="delegation_id" class="w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none">
						<option v-show="organization_id == 2" v-for="(delegation, index) in delegationsElectry" :value="delegation.id" :key="index">
							{{ delegation.name }}
						</option>
						<option v-show="organization_id == 3" v-for="(delegation, index) in delegationsEnergo" :value="delegation.id" :key="index">
							{{ delegation.name }}
						</option>
					</select>
				</div>
			</div>
			<div class="lg:flex">
				<div class="lg:w-1/2 mb-4 lg:pr-2">
					<div class="mb-4">
						<label class="block mb-2">{{ $t('Nombre') }}</label>
						<input type="text" v-model="name" class="mt-2 w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none" />
					</div>
				</div>
				<div class="lg:w-1/2 mb-4 lg:pl-2">
					<label class="block mb-2">{{ $t('Cargo') }}</label>
					<input type="text" v-model="charge" class="mt-2 w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none" />
				</div>
			</div>
			<div class="lg:flex">
				<div class="lg:w-1/2 mb-4 lg:pr-2">
					<div class="mb-4">
						<label class="block mb-2">{{ $t('Telefono_movil') }}</label>
						<input type="text" v-model="cellphone" @keydown="validateNumber($event)" minlength="9" maxlength="9" class="mt-2 w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none" />
					</div>
				</div>
				<div class="lg:w-1/2 mb-4 lg:pl-2">
					<div class="mb-4">
						<label class="block mb-2">{{ $t('Telefono') }}</label>
						<input type="text" v-model="phone" @keydown="validateNumber($event)" minlength="9" maxlength="9" class="mt-2 w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none" />
					</div>
				</div>
			</div>
			<div class="lg:flex">
				<div class="lg:w-1/2 mb-4 lg:pr-2">
					<div class="mb-4">
						<label class="block mb-2">{{ $t('email') }}</label>
						<input type="text" v-model="email" class="mt-2 w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none" />
					</div>
				</div>
				<div class="lg:w-1/2 mb-4 lg:pl-2">
					<div class="mb-4">
						<label class="block mb-2">{{ $t('address') }}</label>
						<input type="text" v-model="address" class="mt-2 w-full border-t-0 border-r-0 border-l-0 border-b border-solid border-inputGrey outline-none" />
					</div>
				</div>
			</div>
			<div class="flex justify-end">
				<ButtonBlack class="mt-4" @click.native="onCreateSign()">
					<div v-if="loading">
						<pulse-loader :loading="loading" :color="'#fff'" :size="'10px'"></pulse-loader>
					</div>
					<div v-else>
						{{ buton_text }}
					</div>
				</ButtonBlack>
			</div>
			<div v-if="error" class="mt-4">
				<p class="text-sm">{{ $t('server_error') }}</p>
				<p class="text-sm text-red-500" v-html="server_error"></p>
			</div>
		</div>
	</Container>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { single } from '@/mixins'
import { fetchOrganizationsSigns } from '@/apollo/organizations'

export default {
	apollo: {
		organizations: fetchOrganizationsSigns(),
	},
	data() {
		return {
			section: 'generar-firmas',
			organizations: [],
			organization_id: process.env.VUE_APP_DEFAULT_ORGANIZATION_ID,
			delegationsElectry: [
				{ id: '', name: '' },
				{ id: 'a-coruna', name: 'A Coruña' },
				{ id: 'albacete', name: 'Albacete' },
				{ id: 'alicante', name: 'Alicante' },
				{ id: 'algeciras', name: 'Algeciras' },
				{ id: 'asturias', name: 'Asturias' },
				{ id: 'baena', name: 'Baena' },
				{ id: 'badajoz', name: 'Badajoz' },
				{ id: 'badajoz-este', name: 'Badajoz Este' },
				{ id: 'badajoz', name: 'Badajoz' },
				{ id: 'barcelona', name: 'Barcelona' },
				{ id: 'bilbao', name: 'Bilbao' },
				{ id: 'cadiz', name: 'Cadiz' },
				{ id: 'canarias', name: 'Canarias' },
				{ id: 'cambrils', name: 'Cambrils' },
				{ id: 'castellon', name: 'Castellon' },
				{ id: 'castuera', name: 'Castuera' },
				{ id: 'castro-urdiales', name: 'Castro Urdiales' },
				{ id: 'ceuta', name: 'Ceuta' },
				{ id: 'cordoba', name: 'Cordoba' },
				{ id: 'cuenca', name: 'Cuenca' },
				{ id: 'estepona', name: 'Estepona' },
				{ id: 'girona', name: 'Girona' },
				{ id: 'granada', name: 'Granada' },
				{ id: 'guadalajara', name: 'Guadalajara' },
				{ id: 'gran-canaria', name: 'Gran Canaria' },
				{ id: 'huesca', name: 'Huesca' },
				{ id: 'huelva', name: 'Huelva' },
				{ id: 'islas-baleares', name: 'Islas Baleares' },
				{ id: 'lanzarote', name: 'Lanzarote' },
				{ id: 'las-palmas', name: 'Las Palmas' },
				{ id: 'lleida', name: 'Lleida' },
				{ id: 'madrid', name: 'Madrid' },
				{ id: 'malaga', name: 'Malaga' },
				{ id: 'mallorca', name: 'Mallorca' },
				{ id: 'murcia', name: 'Murcia' },
				{ id: 'ourense', name: 'Ourense' },
				{ id: 'plasencia', name: 'Plasencia' },
				{ id: 'salamanca', name: 'Salamanca' },
				{ id: 'segovia', name: 'Segovia' },
				{ id: 'sevilla', name: 'Sevilla' },
				{ id: 'soria', name: 'Soria' },
				{ id: 'tarragona', name: 'Tarragona' },
				{ id: 'tarazona', name: 'Tarazona de la mancha' },
				{ id: 'tenerife', name: 'Tenerife' },
				{ id: 'teruel', name: 'Teruel' },
				{ id: 'toledo', name: 'Toledo' },
				{ id: 'torrijos', name: 'Torrijos' },
				{ id: 'valencia', name: 'Valencia' },
				{ id: 'valladolid', name: 'Valladolid' },
				{ id: 'el-vendrell', name: 'Vendrell' },
				{ id: 'vigo', name: 'Vigo' },
				{ id: 'zaragoza', name: 'Zaragoza' },
				{ id: 'zamora', name: 'Zamora' },
			],
			delegationsEnergo: [
				{ id: '', name: '' },
				{ id: 'a-coruna', name: 'A Coruña' },
				{ id: 'alicante', name: 'Alicante' },
				{ id: 'almeria', name: 'Almería' },
				{ id: 'barcelona', name: 'Barcelona' },
				{ id: 'caceres', name: 'Cáceres' },
				{ id: 'cadiz', name: 'Cádiz' },
				{ id: 'ciudad-real', name: 'Ciudad Real' },
				{ id: 'eibar', name: 'Eibar' },
				{ id: 'girona', name: 'Girona' },
				{ id: 'granada', name: 'Granada' },
				{ id: 'las-palmas', name: 'Las Palmas' },
				{ id: 'madrid', name: 'Madrid' },
				{ id: 'mallorca', name: 'Mallorca' },
				{ id: 'murcia', name: 'Murcia' },
				{ id: 'malaga', name: 'Málaga' },
				{ id: 'oviedo', name: 'Oviedo' },
				{ id: 'pontevedra', name: 'Pontevedra' },
				{ id: 'san-sebastian', name: 'San Sebastián' },
				{ id: 'santander', name: 'Santander' },
				{ id: 'sevilla', name: 'Sevilla' },
				{ id: 'tenerife', name: 'Tenerife' },
			],
			delegation_id: '',
			name: '',
			address: '',
			charge: '',
			phone: '',
			email: '',
			cellphone: '',
		}
	},
	components: { PulseLoader },
	mixins: [single],
	validations() {
		return {
			organization_id: {
				required,
			},
		}
	},
	methods: {
		onCreateSign() {
			this.$v.$touch()
			if (!this.$v.$invalid) {
				const payload = {}
				if (this.organization_id !== '') {
					payload.companyId = this.organization_id
				}
				if (this.delegation_id !== '') payload.delegation = this.delegation_id
				if (this.name !== '') payload.name = this.name
				if (this.charge !== '') payload.position = this.charge
				if (this.cellphone !== '') payload.cellphone = this.cellphone
				if (this.phone !== '') payload.phonenumber = this.phone
				if (this.email !== '') payload.email = this.email
				if (this.address !== '') payload.direction = this.address
				window.open(`${process.env.VUE_APP_API_URL}/sign/?${new URLSearchParams(payload).toString()}`)
			} else {
				let error_list = this.$t('form_validation')
				this.setError(error_list)
			}
		},
		cleanFields() {
			this.name = ''
			this.address = ''
			this.charge = ''
			this.phone = ''
			this.email = ''
			this.cellphone = ''
		},
		validateNumber() {
			if (event.key != 'Backspace' && isNaN(event.key) && event.key != 'Tab') event.preventDefault()
		},
	},
}
</script>
